import { TableCell, TableRow } from '@carbon/react';
import classnames from 'classnames';
import styles from '../allocation-manager.module.scss';
import { AllocationManagerTotalRowsProps } from 'pages/development-areas/show/allocation-manager-types';
import { LineItemValueCell } from './line-item-value-cells';

export const AllocationManagerTotalRows = ({
  totals,
  checkAllocations,
  renderLateralLengthValues,
  unitPlatGrossAcres,
  wellPlatTotalLateralLength,
  totalGisLateralSourced,
  totalGisAcreageSourced,
}: AllocationManagerTotalRowsProps) => (
  <>
    <TableRow className={styles.boldRow}>
      <TableCell className={styles.titleCell}>Total Value (Sum)</TableCell>
      <LineItemValueCell
        value={totals.acreageValue}
        className={styles.leftBorder}
        warnings={checkAllocations.map((w) => w.id)}
        warningIds={[
          'acreage-value-total-breach',
          'acreage-factor-total-breach',
        ]}
      />
      <LineItemValueCell
        value={totals.acreageFactor * 100}
        isPercentage
        warnings={checkAllocations.map((w) => w.id)}
        warningIds={['acreage-factor-total-breach']}
      />
      <LineItemValueCell
        value={totals.acreageGisValue}
        warnings={checkAllocations.map((w) => w.id)}
        warningIds={['acreage-value-total-breach']}
      />
      {renderLateralLengthValues && (
        <>
          <LineItemValueCell
            value={totals.lateralValue}
            className={styles.leftBorder}
            warnings={checkAllocations.map((w) => w.id)}
            warningIds={[
              'lateral-value-total-breach',
              'lateral-factor-total-breach',
            ]}
          />
          <LineItemValueCell
            value={totals.lateralFactor * 100}
            isPercentage
            warnings={checkAllocations.map((w) => w.id)}
            warningIds={['lateral-factor-total-breach']}
          />
          <LineItemValueCell
            value={totals.lateralGisValue}
            warnings={checkAllocations.map((w) => w.id)}
            warningIds={['lateral-value-total-breach']}
          />
        </>
      )}
    </TableRow>
    <TableRow className={classnames(styles.boldRow, styles.noBorder)}>
      <TableCell className={styles.titleCell}>Sourced vs GIS</TableCell>
      <LineItemValueCell
        value={unitPlatGrossAcres}
        className={styles.leftBorder}
        warnings={checkAllocations.map((w) => w.id)}
        warningIds={['acreage-gis-value-breach', 'acreage-factor-total-breach']}
      />
      <TableCell />
      <LineItemValueCell
        value={totalGisAcreageSourced}
        warnings={checkAllocations.map((w) => w.id)}
        warningIds={['acreage-gis-value-breach']}
      />
      {renderLateralLengthValues && (
        <>
          <LineItemValueCell
            value={wellPlatTotalLateralLength}
            className={styles.leftBorder}
            warnings={checkAllocations.map((w) => w.id)}
            warningIds={[
              'lateral-gis-value-breach',
              'lateral-factor-total-breach',
            ]}
          />
          <TableCell />
          <LineItemValueCell
            value={totalGisLateralSourced}
            warnings={checkAllocations.map((w) => w.id)}
            warningIds={['lateral-gis-value-breach']}
          />
        </>
      )}
    </TableRow>
  </>
);
